<div class="container mt-5"  *ngIf="(track | async) as tr">
    <div class="row">
        <div class="col-md-6">
            <div>
                <h4>Origen</h4>
                <p class="info">{{tr?.cityStart}}</p>
            </div>
        </div>
        <div class="col-md-6">
            <h4>Destino</h4>
            <p class="info">{{tr?.cityEnd}}</p>
        </div>
    </div>
    <div class="mt-3">
        <h4>Descripción</h4>
        <p class="info">{{tr?.description}}</p>
    </div>
    <div class="">
        <div class="mt-4 container-picture" >
          <div *ngFor = "let img of (images | async)">
            <a href="{{img.url}}" target="_blank"><div class="picture"><img src="{{img.url}}"/></div></a>
          </div>
         <div class="picture btn more" title="Añadir una imagen" data-toggle="modal" data-target="#modalMore" data-placement="Añadir imagen"><i class="far fa-plus-square"></i></div>
        </div>
      
    </div>
</div>


<div class="modal" tabindex="-1" role="dialog" id="modalMore">
    <div class="modal-dialog" role="document">
      <div class="modal-content ">
          <div class="modal-header">
            <h5 class="modal-title" id="titleDeleteSocial"><i>Subir Imágenes</i></h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body m-3" align="center">
            <div class="contenedor">
                <div class="contenedor_formulario">  
                    <p class="download" *ngIf="finalizado"> EL archivo se subió correctamente.</p>
            <form [formGroup]="archivoForm" (ngSubmit)="subirArchivo()" >
                <div class="file has-name is-boxed">
                    <label class="">
                      <input class="file-input" type="file" formControlName="archivo" (change)="cambioArchivo($event)">
                      <span class="file-cta">
                        <span class="file-label btn btn-primary bg-success">
                          Elegir un archivo…
                        </span>
                      </span><br>
                      <span class="file-name">
                        {{ mensajeArchivo }}
                      </span>
                    </label>
                  </div><hr>
                <progress *ngIf="porcentaje > 0 && porcentaje < 100" class="progress is-large is-success" value="{{porcentaje}}" max="100">{{porcentaje}}%</progress>
                <button [ngClass]="{'button': true, 'is-success': true, 'is-large': true, 'is-loading': porcentaje > 0 && porcentaje < 100}" class="mt-3 btn btn-primary"
                     [disabled]="!archivoForm.valid && (porcentaje > 0 && porcentaje < 100)">Subir archivo</button>          
            </form>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>